import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module';
import { BlankComponent } from './layouts/blank/blank.component';
import {AuthInterceptor} from './shared/interceptor/auth.interceptor';
import {AuthExpiredInterceptor} from './shared/interceptor/auth-expired.interceptor';
import {AuthenticationModule} from './authentication/authentication.module';
import {FrontEndCoreModule} from './core/core.module';
import {SharedModule} from './singelton/singelton.module';
import {AppConfigService} from './appconfig.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import {TransactionUpdateComponent} from "./entities/transaction/transaction-update.component";
import {ToastrModule} from "ngx-toastr";
import {DpDatePickerModule} from "ng2-jalali-date-picker";
import {AutocompleteLibModule} from "angular-ng-autocomplete";
import {FileObjectUpdateComponent} from "./entities/file/file-object-update.component";
import {ImpersonatePopupComponent} from "./shared/sidebar/impersonate.popup.component";
import {TransactionUpdatePeriodicComponent} from "./entities/transaction/transaction-update-periodic.component";
import {SettingUpdateComponent} from "./entities/setting/setting-update.component";
import {NgxPrintModule} from "ngx-print";
import {AdvancedSearchCustomerComponent} from "./extra/customer/advanced-search-customer.component";
import {AdvancedSearchGeneralComponent} from "./extra/advanced-search-general.component";
import {AdvancedSearchPhoneComponent} from "./extra/phone/advanced-search-phone.component";
import {AdvancedSearchProjectComponent} from "./extra/project/advanced-search-project.component";
import {AdvancedSearchSalesCycleComponent} from "./extra/salesCycles/advanced-search-salesCycle.component";
import {ProjectUpdateComponent} from "./entities/project/project-update.component";
import {PhoneUpdateComponent} from "./entities/phone/phone-update.component";
import {FileObjectPrjUpdateComponent} from "./entities/file/file-object-prj-update.component";
import {NotificationDialogComponent} from './dashboards/dashboard1/notification-dialog.component';
// import {TicketUpdateComponent} from "./entities/ticket/ticket-update.component";
// import {QuillModule} from "ngx-quill";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};
// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

/// Initialization at StartUp (resolving Account and Identity)
export function appInit(appConfigService: AppConfigService) {
  return () => appConfigService.initializeApp();
}

@NgModule({
  declarations: [
    ImpersonatePopupComponent,
    AppComponent,
    SpinnerComponent,
    FullComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent, BlankComponent,
    TransactionUpdateComponent,TransactionUpdatePeriodicComponent,ProjectUpdateComponent,PhoneUpdateComponent,
    // TicketUpdateComponent,
    FileObjectUpdateComponent,
    FileObjectPrjUpdateComponent,
    SettingUpdateComponent,AdvancedSearchCustomerComponent,AdvancedSearchGeneralComponent,AdvancedSearchPhoneComponent,
    AdvancedSearchProjectComponent,AdvancedSearchSalesCycleComponent,
    NotificationDialogComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    NgxPrintModule,
    // QuillModule,
    // RouterModule.forRoot(Approutes, {useHash:true}),
    RouterModule.forRoot(Approutes, {
      useHash: true
    }),

    PerfectScrollbarModule,
    LanguageTranslationModule,
    SharedModule.forRoot(),
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    DpDatePickerModule,
    AutocompleteLibModule,

    //FrontEndCoreModule
    //.forRoot()
   // AuthenticationModule.forRoot()

    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // })
  ],
  entryComponents: [SettingUpdateComponent,TransactionUpdateComponent,TransactionUpdatePeriodicComponent,
    FileObjectUpdateComponent,
    FileObjectPrjUpdateComponent,
    ImpersonatePopupComponent,ProjectUpdateComponent,PhoneUpdateComponent,
    NotificationDialogComponent/*,TicketUpdateComponent*/],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [AppConfigService]
    }
    ,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthExpiredInterceptor,
    multi: true
  }
    ,
    NgbActiveModal
],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  bootstrap: [AppComponent]
})
export class AppModule { }
